<template lang="pug">
main
  template(v-if='requestSucceeded')
    p If your email address is associated with an account, we have emailed a new {{ typeMessage }} confirmation to you; please click on the verification link in the email to complete your {{ typeMessage }}.
    p If you don't receive the email, please contact your agency to ensure that you have been signed up.

  template(v-else)
    b-form(id='requestEmail' role='form' :action='action' method='post' @submit.stop novalidate)
      //- input(name='_csrf' type='hidden' value='{{csrfToken}}')
      .fl-row.xs-pr-fl-rows.xs-ld-fl-columns.email.form-group
        label.lone-input.emailAddress.fl-column.fixed(for='emailAddress') Your email address:
        IconedInput.fl-column(id='emailAddress' type='text' v-model.trim='form.emailAddress' placeholder='david@brent.co.uk' :icon='$icons.envelope' required autofocus)

      .fl-row.jc-center
        vue-submit.restrict(id='requestEmailSubmit' :running='submitting' @click='submit') {{ submitMessage }}
</template>

<script>
import { Form } from "@/utils/Form/Form";
import { validateEmailAddress } from "@timesheets/validators-common";

export default {
  name: "RequestEmail",
  extends: Form,
  props: {
    route: {
      type: String,
      required: true,
    },
    submitMessage: {
      type: String,
      required: true,
    },
    typeMessage: {
      type: String,
      required: true,
    },
  },
  data() {
    let emailAddress = this.$route.query.emailAddress && this.$route.query.emailAddress.toString();

    return {
      form: {
        emailAddress,
      },
    };
  },
  watch: {
    errors() {
      this.$emit("errors", this.errors);
    },
  },
  methods: {
    validate(form, errors) {
      validateEmailAddress(form.emailAddress, errors, undefined, "SignupGetEmailVerification", { checkCasing: false });
    },
  },
};
</script>
